import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import Hero from '../../components/about/Hero';
import FeatureSection from '../../components/about/FeatureSection';
import FeaturesCards from '../../components/about/FeaturesCards';
import HowItWorksSection from '../../components/about/HowItWorksSection';
import SolutionsSection from '../../components/about/SolutionsSection';
import DifferentialSection from '../../components/about/DifferentialSection';

import React from 'react';
import { Helmet } from 'react-helmet-async';      

const Home = () => {
  return (
    <>

      <Helmet>
        <title>FLOQSS | Transforma tu conocimiento en un negocio digital rentable</title>

        <meta
          name="description"
          content="Transforma tu conocimiento en un negocio digital rentable. FLOQSS te ofrece todas las herramientas que necesitas para ser un Productor exitoso."
        />
      </Helmet>
      <Header />
      <Hero />
      <FeatureSection />
      <FeaturesCards />
      <SolutionsSection />
      <HowItWorksSection />
      <DifferentialSection />
      <Footer />
    </>
  );
};

export default Home;